import styles from './styles.module.scss';

function EmptyKit() {
  return <div className={styles.emptyKit}>No KITs to Display</div>;
}

export default EmptyKit;
